import { ContainerProps } from './types';

export const Container = ({ children, classNames }: ContainerProps) => <div className={`relative ${classNames}`}>{children}</div>;
